export enum GroupMemberRole {
  ADMIN = "Admin",
  MEMBER = "Member",
}

export enum MembershipStatus {
  ACTIVE = "active",
  PENDING = "pending",
  REJECTED = "rejected",
}

export enum JoinType {
  DIRECT_JOIN = "direct_join",
  REQUEST = "request",
  ADDED_BY_ADMIN = "added_by_admin",
}
